import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BaseBoardComponent } from './actionviews/baseBoard';
import { ActiveBoardService } from './services/active-board.service';
import { DynamicElementService } from './services/dynamicElement.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
  })
export class AppComponent implements OnInit {
  title = 'app';
  @ViewChild('dynamicElementInsertionPoint', { read: ViewContainerRef, static: true }) dynamicElementInsertionPoint: ViewContainerRef;

  constructor(
    private translate: TranslateService,
    private dynamicElementService: DynamicElementService,
    private activeBoardService: ActiveBoardService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.dynamicElementService.setInsertionPoint(this.dynamicElementInsertionPoint);
    this.initLanguage();
  }

  private initLanguage(): void {
    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang('en');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.translate.use('de');
    this.translate.use('en');
  }

  public onRouterOutletActivated(board: BaseBoardComponent) {
    this.activeBoardService.setActiveBoard(board);
  }

  isLogin() {
    return this.router.url.startsWith('/login');
  }
}
